import storeFactory from 'common/modules/store'

import createNetworkMiddleWare, { broadcastChannelTransport, _network } from '@piconetworks/network-middleware'
import { _menu } from '@piconetworks/menu-middleware'

import networkMiddlewareConfig from 'common/modules/middleware/networkMiddleware'
import actionReplayMiddleware from 'common/modules/middleware/actionReplayMiddleware'

import Account from 'common/modules/account'
import Auth from 'common/modules/auth'
import Gift from 'common/modules/gift'
import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Payment from 'common/modules/payment'
import Plan from 'common/modules/plan'
import Router from 'common/modules/router'
import Wizard from 'common/modules/wizard'

import { ARBITER_TAG } from 'common/tags'

const generateStoreBundle = () => {
    const storeBundle = storeFactory({
        reducers: {
            _menu,
            _network,
        },
        modules: [
            Account,
            Auth,
            Gift,
            Loader,
            Payment,
            Plan,
            Router,
            Wizard,
        ],
        middleware: [
            actionReplayMiddleware([
                Auth.types.LOGIN_SUCCESS,
                Auth.types.SOCIAL_LOGIN_SUCCESS,
                Auth.types.CLAIM_MAGIC_LINK_SUCCESS,
                Plan.types.PURCHASE_PLAN_SUCCESS,
            ], ({ action, dispatch }) => {
                dispatch(Internal.creators.sendMessage({
                    payload: {
                        target: 'pico_arbiter',
                        ...action,
                    },
                }))
            }),
            createNetworkMiddleWare({
                ...networkMiddlewareConfig,
                transport: (config) => {
                    const { internal } = storeBundle.store.getState()

                    const options = {
                        config,
                        channelId: internal?.channel?.name,
                        custom: {
                            target: ARBITER_TAG,
                            origin: internal?.origin,
                        },
                    }

                    return broadcastChannelTransport.sender(options)
                },
            }),
        ],
    })

    return storeBundle
}

export default generateStoreBundle
